<template>
  <div class="index-activity">

    <div :class="['index-activity-card', bgColorList[activityIndex % 3]]">

      <div class="card-content">
        <div class="card-title">{{activityInfo.activity_name}}</div>
        <div class="card-sub-title">{{activityInfo.subtitle}}</div>

        <div class="card-filter">
          <!-- oss控制是否展示 -->
           <div class="activity-nav-list">
              <activity-nav-list v-model="formInfo.country" :list="productCountryList" :show-option-all="true" v-if="activityInfo.enabled_country_filter && productCountryList.length"></activity-nav-list>
           </div>
          <province-box :is-issue-place="false" v-model="formInfo.provinceCode" class="selector"></province-box>
        </div>

        <activity-product-list 
          :list="filterProductList.slice(0, 6)"
          :activity-info="activityInfo" 
          :activity-index="activityIndex"
          :province-code="formInfo.provinceCode">
        </activity-product-list>
      

        <div class="more-btn" v-if="filterProductList.length">
          <button class="s-btn btn-orange icon-more is-plain is-round" @click="goActivityDetail($event, activityInfo.id)">查看更多商品</button>
        </div>

      </div>
      
    </div>
    
  </div>
</template>


<script>
import sensorsdata from 'sa-sdk-javascript';
import ActivityNavList from '@/components/activity/index-activity/activity-nav-list.vue';
import ActivityProductList from './components/activity-product-list.vue';
import ProvinceBox from '@/components/common/provinces-box';
import sensorService from '@/services/sensor-service.js';

export default {
  name: 'index-activity',
  components: {
    ActivityNavList,
    ActivityProductList,
    ProvinceBox,
  },
  props: {
    activityInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    activityIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formInfo: {
        country: undefined,
        provinceCode: 0,
      },
      bgColorList: [
        'blue', 'orange', 'red',
      ],
    };
  },
  computed: {
    // 省份筛选
    filterProvinceProductList() {
      if (!this.activityInfo) return [];
      const productList = this.activityInfo.activity_product || [];
      if (!this.formInfo.provinceCode) return productList;
      return productList.filter(item => item.cover_province.some(province => province === this.formInfo.provinceCode));
    },
    // 根据省份筛选获取国家列表
    productCountryList() {
      const provinceProductList = this.filterProvinceProductList || [];
      const allProductCountryList = provinceProductList.map(item => item.country);
      // 去重
      return [...new Set(allProductCountryList)].slice(0, 6);
    },
    // 显示的商品列表-->省份+国家筛选
    filterProductList() {
      const provinceProductList = this.filterProvinceProductList || [];
      if (!this.formInfo.country) return provinceProductList;
      return provinceProductList.filter(item => item.country === this.formInfo.country);
    },
  },
  watch: {
    'formInfo.provinceCode': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 切换地区重置国家为全部
          this.formInfo.country = undefined;
        }
      },
    },
  },
  methods: {
    goActivityDetail(e, id) {
      sensorsdata.quick('trackHeatMap', e.target);
      const url = sensorService.getURL(`${location.href}activity?id=${id}`, '首页-电子签专区');
      window.open(url);
    },
  },

};

</script>

<style lang="less" scoped>
.index-activity {

  .index-activity-card {
    &.blue, &.orange, &.red {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        width: 1120px;
        height: 320px;
      }
      .card-title {
        position: relative;
        &::before {
          content: "";
          width: 80px;
          height: 8px;
          background: linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
          opacity: 0.8;
          position: absolute;
          bottom: -4px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    &.blue {
      background: linear-gradient(180deg,rgba(89,159,255,0.04) 0%,rgba(89,159,255,0) 100%);
      .card-title::before {
        background: linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
      }
    }
    &.blue::before {
      background: url('https://o.666visa.cn/static/ssqpeer/homepage/activity-bg-blue.png') no-repeat;
      background-size: 100% 100%;
    }
    &.orange {
      background: linear-gradient(180deg,rgba(255,132,66,0.04) 0%,rgba(255,132,66,0) 100%);
      .card-title::before {
        background: linear-gradient(270deg,rgba(255,132,66,0) 0%,rgba(255,132,66,0.8) 50%,rgba(255,132,66,0) 100%);
      }
    }
    &.orange::before {
      background: url(https://o.666visa.cn/static/ssqpeer/homepage/activity-bg-orange.png) no-repeat;
      background-size: 100% 100%;
    }
    &.red {
      background: linear-gradient(180deg,rgba(255,100,100,0.04) 0%,rgba(255,100,100,0) 100%);
      .card-title::before {
        background: linear-gradient(270deg,rgba(255,100,100,0) 0%,rgba(255,100,100,0.8) 50%,rgba(255,100,100,0) 100%);
      }
    }
    &.red::before {
      background: url(https://o.666visa.cn/static/ssqpeer/homepage/activity-bg-red.png) no-repeat;
      background-size: 100% 100%;
    }
    .card-content {
      padding: 48px 0;
      width: 1120px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }

    .card-title {
      font-size: 32px;
      color: #2F333D;
      line-height: 32px;
      font-weight: 600;
    }
    .card-sub-title {
      margin-top: 16px;
      font-size: 16px;
      color: #91999F;
      line-height: 22px;
      letter-spacing: 4px;
    } 

    .card-filter {
      width: 100%;
      margin-top: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .activity-nav-list {
        max-width: calc(~"1120px - 140px");
        flex: 1;
      }
      .selector {
        flex-shrink: 0;
        border: none;
        position: relative;
        left: 12px;
      }
    }
    .more-btn {
      margin-top: 32px;
      /deep/ .s-btn.btn-orange.icon-more {
        &::after {
          content: '';
          margin-left: 6px;
          width: 13px;
          height: 10px;
        }
      }
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/index-activity/index-activity.vue